<template>
    <!--弹窗-->
    <!-- <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    > -->
    <div>
        <div style="display:flex;">
            <el-form
                ref="form"
                class="query-form"
                size="mini"
                label-width="130px"
                style="padding: 0 "
            >
                <el-form-item label="广告组合编号:" required>
                    <el-input
                        style="width: 320px;"
                        placeholder="请输入广告组合编号"
                        v-model="ad_group_no"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="广告组合名称:" required>
                    <el-input
                        style="width: 320px;"
                        placeholder="请输入广告组合名称"
                        v-model="ad_group_name"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="sku数据模板:">
                    <div>
                        <a
                            href="/export/SKU数据模板.xlsx"
                            style="text-decoration: underline; color: rgb(58, 142, 230);"
                            >点击下载“sku数据模板”模板</a
                        >
                    </div>
                </el-form-item>
            </el-form>
            <div class="download" style="margin-left:20px">
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        :file-list="fileList"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                        <div
                            class="el-upload__text"
                            style="font-size: 12px;margin-top: 5px;"
                        >
                            只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </div>
        </div>

        <el-form>
            <el-table
                :data="list"
                size="mini"
                ref="multipleTable"
                class="table_content mini_div"
                border
                style="width: 50%; margin-top: 20px;"
            >
                <el-table-column label="SKU" width="150" align="center">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.sku }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="asin" width="150" align="center">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.asin }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="产品名字" width="150" align="center">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.product_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="专有属性" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="index / 2 === 0 ? 'success' : ''"
                            style="margin-right: 5px;"
                            v-for="(item, index) in scope.row.property"
                            effect="dark"
                            :key="index"
                            >{{ item }}</el-tag
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top:17px; width: 50%; padding-bottom: 40px">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                    >取 消</el-button
                >
                <el-button
                    style="float:right"
                    size="mini"
                    type="primary"
                    @click="submitForm"
                    >确定</el-button
                >
            </div>
        </el-form>
        <!-- <el-row style=" text-align: center;">
            <el-button
                style="width:90%;margin:auto"
                @click="addList"
                size="mini"
                type="primary"
                >添加sku</el-button
            >
        </el-row> -->
    </div>
    <!-- </el-dialog> -->
</template>
<script>
import * as api from "@/api/statistics/statistics";

export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        },
        state: String,
        asin: Number
    },
    data() {
        return {
            limitUpload: 1,
            obj: {},
            loading: false,
            fileList: [],
            dateArr: [],
            rules: {
                project_name: [
                    {
                        required: true,
                        message: "请输入项目组",
                        trigger: "blur"
                    }
                ],
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ]
            },
            listData: {},
            list: [],
            ad_group_name: "",
            ad_group_no: ""
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const loading = this.$loading({
                lock: true,
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.sb_ad_data_get_ad_base_group_message({
                asin_id: this.$route.query.ad_portfolio_name_id,
                state: this.$route.query.state
            })
                .then(res => {
                    this.list = res.data.data || [];
                    // this.list = this.list.map(item => {
                    //     let property = "";
                    //     item.property.forEach(element => {
                    //         property = property + element + "\n";
                    //     });
                    //     item.property = property;
                    //     return item;
                    // });
                    this.ad_group_name = res.data.ad_group_name;
                    this.ad_group_no = res.data.ad_group_no;
                    if (!this.list.length) this.addList();
                })
                .finally(() => {
                    loading.close();
                });
        },
        addList() {
            this.list.push({
                sku: "",
                asin: "",
                product_name: "",
                property: ""
            });
        },
        deleteRow(index) {
            this.list.splice(index, 1);
        },
        // 保存信息
        submitForm() {
            let force = 0;
            if (!this.ad_group_no) {
                return this.$message.error("请输入广告组合编号");
            }
            if (!this.ad_group_name) {
                return this.$message.error("请输入广告组合名称");
            }
            if (this.list.length) {
                for (let i = 0; i < this.list.length; i++) {
                    if (!this.list[i].sku) {
                        return this.$message.error(`第${i + 1}行sku不能为空`);
                    }
                }
            } else {
                return this.$message.error("请输入sku,sku数据至少一条");
            }

            this.$confirm("是否确定上传 SKU 数据", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    force = 1;
                    this.update();
                })
                .finally(() => {
                    // this.update(force);
                });
        },
        // 保存信息
        update(force) {
            const loading = this.$loading({
                lock: true,
                text: "修改中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            // let newList = JSON.parse(JSON.stringify(this.list));
            // newList = newList.map(item => {
            //     if (item.property) {
            //         item.property = String(item.property)
            //             .split("\n")
            //             .filter(item => item !== "");
            //     } else {
            //         item.property = [];
            //     }

            //     return item;
            // });
            // newList = newList.filter(item => {
            //     return (
            //         (item.sku !== "" && item.asin !== "") ||
            //         item.product_name !== "" ||
            //         item.property.length !== 0
            //     );
            // });

            const data = {
                asin_id: this.$route.query.ad_portfolio_name_id,
                asin: this.$route.query.asin,
                state: this.$route.query.state,
                ad_group_no: this.ad_group_no,
                ad_group_name: this.ad_group_name,
                data: this.list
            };
            api.sb_ad_data_add_ad_base_group_message(data)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(true);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                })
                .finally(() => {
                    loading.close();
                });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit("close-callback", isshow);
        },
        //上传Excel文件的处理方法
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            this.fileTemp = file.raw;
            let extend = this.fileTemp.name.substring(
                this.fileTemp.name.lastIndexOf("."),
                this.fileTemp.name.length
            );
            if (this.fileTemp) {
                if (extend == ".xlsx" || extend == ".xls") {
                    this.importfxx(this.fileTemp);
                } else {
                    this.$message({
                        type: "warning",
                        message: "附件格式错误，请删除后重新上传!"
                    });
                }
            } else {
                this.$message({
                    type: "warning",
                    message: "请上传附件!"
                });
            }
        },
        //超过上载文件的最大数量限制如何删除文件
        handleRemove() {
            this.fileList = [];
            this.fileTemp = null;
            this.obj = {};
        },
        //超过最大上传文件数时的处理方法
        handleExceed() {
            this.$message({
                type: "warning",
                message: "超过上载文件的最大数量限制!"
            });
            return;
        },
        importfxx(obj) {
            const _this = this;
            // const inputDOM = this.$refs.inputer;
            // 通过DOM检索文件数据
            this.file = obj;
            var rABS = false; //通过DOMRead检索文件数据将文件作为二进制字符串读取
            var f = this.file;
            var reader = new FileReader();
            // if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function(f) {
                var binary = "";
                var rABS = false; //将文件作为二进制字符串读取
                // var pt = this;
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function() {
                    var bytes = new Uint8Array(reader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    //如果main.js中没有介绍，那么您需要在这里介绍它来解析excel
                    var XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(binary), {
                            //手动转换
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(
                        wb.Sheets[wb.SheetNames[0]]
                    );
                    //数据可以在这里处理。
                    const arr = [];
                    outdata.map(v => {
                        const obj = {};
                        obj["sku"] = v["SKU"];
                        obj["product_name"] = v["品名"];
                        obj["asin"] = v["asin"];
                        obj["property"] =
                            (v["专有属性"] &&
                                String(v["专有属性"]).split("\n")) ||
                            [];
                        arr.push(obj);
                    });
                    _this.list = arr;
                    return arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.acos{
		margin-left: -155px;
		.acosItem{
			float: left;
			width:300px;
			text-align: right;
		}
	}
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
